import { render, staticRenderFns } from "./Trtc.vue?vue&type=template&id=6460ab38&scoped=true&"
import script from "./Trtc.vue?vue&type=script&lang=js&"
export * from "./Trtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460ab38",
  null
  
)

export default component.exports